module.exports = __webpack_public_path__ + "static/amasyaEt-e68c4a55c5de820eef8fc245b8cc7907.png";